import { render, staticRenderFns } from "./bodyPartModel.vue?vue&type=template&id=70ffe294"
import script from "./bodyPartModel.vue?vue&type=script&lang=js"
export * from "./bodyPartModel.vue?vue&type=script&lang=js"
import style0 from "./bodyPartModel.vue?vue&type=style&index=0&id=70ffe294&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports